<div class="panel" *ngIf="panel">
  <span *ngIf="title" class="label">{{ title }}</span>
  <button type="button" class="value" [disabled]="disabled" (click)="open()">
    {{ faceLabel }}
  </button>
</div>

<ion-modal
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  [handle]="false"
  [keepContentsMounted]="true"
>
  <ng-template>
    <div class="picker">
      <ion-picker>
        <!-- Two columns: the sound library, then the auto-stop duration. -->
        <ion-picker-column
          [value]="selectedSound"
          (ionChange)="onSoundChange($event)"
        >
          <ion-picker-column-option
            *ngFor="let s of displaySounds"
            [value]="s.id"
          >{{ s.name }}</ion-picker-column-option>
        </ion-picker-column>

        <ion-picker-column
          [value]="selectedDuration"
          (ionChange)="onDurationChange($event)"
        >
          <ion-picker-column-option
            *ngFor="let d of durations"
            [value]="d"
          >{{ durationLabel(d) }}</ion-picker-column-option>
        </ion-picker-column>
      </ion-picker>

      <!--
        Volume is LIVE: it commits on knob release, not on Set. That is the one
        seam in this sheet — drag the slider then dismiss without tapping Set and
        the volume sticks while the wheels are discarded — and it is deliberate,
        because a level you cannot hear while choosing it is not a volume control.
        The divider is what signals the difference.
      -->
      <div class="volume" *ngIf="showVolume">
        <div class="volume-header">
          <span class="volume-label">Volume</span>
          <span class="volume-value">{{ sliderVolume }}%</span>
        </div>
        <!-- No endpoint labels: the live readout above the bar already names the
             level, and a 1 / 100 pair inside the track only competes with it. -->
        <ion-range
          [min]="volumeMin"
          [max]="volumeMax"
          [step]="volumeStep"
          [(ngModel)]="sliderVolume"
          [ngModelOptions]="{ standalone: true }"
          aria-label="Volume"
          (ionKnobMoveStart)="onVolumeKnobStart()"
          (ionKnobMoveEnd)="onVolumeKnobEnd($event)"
        ></ion-range>
      </div>

      <div class="button" (click)="onApply()">Set</div>
    </div>
  </ng-template>
</ion-modal>
